import module from 'module';

module.directive('textOnly', () => {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, element, attributes, ngModel) {
      if (!ngModel) return;

      scope.$watch('textOnly', () => {
        validate();
      });

      let validate = () => {
        const regExp = /^[A-Za-z ]+$/;

        ngModel.$validators.textOnly = (modelValue) => {
          if (!modelValue || !modelValue.length) return true;
          return regExp.test(modelValue);
        }

        // Force validation.
        ngModel.$validate();
      }
    }
  }
});